<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showNewEquipo"
    no-close-on-backdrop
    size="sm"
    :title="accion == 'i' ? 'Agregar Equipo' : 'Cambiar categoria'"
    cancel-variant="outline-secondary"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <b-row>
      <b-col md="12" class="mt-1">
        <v-select
          placeholder="Seleccione Categoria"
          :options="listCategoriasAdmin"
          :clearable="false"
          style="width: 100%"
          v-model="equipo.categoria"
        />
      </b-col>
      <b-col md="12" class="mt-2">
        <b-form-group label="Equipo a crearse" label-for="phone">
          <b-input-group>
            <b-input-group-prepend is-text>
              {{ institucion.apodo }}
            </b-input-group-prepend>
            <cleave
              id="phone"
              v-model="equipo.alias_equipo"
              class="form-control"
              :raw="false"
              :options="opt"
              placeholder="Distintivo"
              style="textTransform: uppercase"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <div
      style="font-size:11px; background:#f7f418; padding:10px; border-radius:4px"
    >
      <span
        >El disitintivo debe usarse para el caso que tengas dos o mas equipos en
        la misma categoria:<br />Ejemplo<br />
        Futbol maxima {{ institucion.apodo }}<br />Futbol Maxima
        {{ institucion.apodo }} B<br />Futbol Maxima
        {{ institucion.apodo }} Reserva<br />SI solo tienes un equipo en la
        categoria No ingrese el distintivo</span
      >
    </div>
    <template #modal-footer>
      <div class="w-100">
        <template>
          <b-button variant="primary" class="float-right" @click="handleOk">
            <span v-if="accion == 'i'">Agregar</span>
            <span v-else>Actualizar</span>
          </b-button>
          <b-button
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cerrar
          </b-button>
        </template>
      </div>
    </template>
  </b-modal>
</template>
<script>
import store from '@/store'
import {
  BModal,
  BRow,
  BCol,
  // BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BButton,
  // xx
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    // BFormInput,
    vSelect,
    BFormGroup,
    BInputGroup,
    Cleave,
    BInputGroupPrepend,
    BButton,
  },
  props: {
    equipo: Object,
    equipoAux: Object,
    institucion: Object,
    listCategoriasAdmin: Array,
    accion: String,
  },
  setup(props, { emit }) {
    // const categoriaAdmin = ref(null)
    const apodo = ref('')
    const opt = ref({
      blocks: [100],
    })
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      //   initModal()
      //   emit('recargar')
      store.commit('someVariables/UPDATE_SHOW_NEW_EQUIPO', false)
      props.equipo.categoria = undefined
      props.equipo.alias_equipo = ''
    }
    function handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // console.log(props.equipo.categoria)
      if (props.equipo.categoria === undefined) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Seleccione la categoria',
              icon: 'CheckIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          }
        )
      } else {
        emit('agregarEquipo', props.equipo)
      }
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_EQUIPO', false)
      props.equipo.categoria = undefined
      props.equipo.alias_equipo = ''
    }
    return {
      resetModal,
      //   categoriaAdmin,
      //   apodo,
      handleOk,
      apodo,
      opt,
      onlyClose,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
